import React from 'react';

export default function Choose() {
  return (
    <>
    <section className='mx-auto justify-center scroll-smooth duration-500 text-[#e0e0e0] lg:pt-40 md:pt-20 pt-10'>
        <div className='mx-auto lg:px-10 sm:px-10 md:px-10 px-5 max-w-screen-2xl'>
            <div className='justify-center w-full mx-auto text-[#000]'>
                <h1 className='md:text-4xl text-xl mx-auto text-[#000] justify-center md:text-center'>
                    Why Partner with Elite Crown for Cybersecurity?
                </h1>
                <div className='grid lg:grid-cols-4 md:grid-cols-2 md:gap-x-5 justify-between mx-auto md:pt-10'>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 md:mx-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Expertise
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            Leverage our extensive knowledge and experience in cybersecurity to safeguard your operations against sophisticated digital threats.
                        </p>
                    </div>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 md:mx-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Customized Solutions
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            ROur services are tailored to meet the unique needs and challenges of your business, ensuring optimal protection.
                        </p>
                    </div>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 md:mx-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Proactive Defense
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            With our proactive approach to cybersecurity, we anticipate and neutralize threats before they can impact your business.
                        </p>
                    </div>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 md:mx-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Peace of Mind
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            Knowing your digital assets are protected by Elite Crown Investments allows you to focus on growing your business with confidence.
                        </p>
                    </div>
                </div>
                <div className='justify-center mx-auto w-full bg-[#B49763] px-5 md:mt-10 mt-5'>
                    <div className='text-[#fff] max-w-screen-xl mx-auto justify-center md:py-20 py-10 text-center md:text-xl text-xs'>
                        <p>
                            Protect your digital assets and ensure the continuity of your operations with Elite Crown Investments' cybersecurity services – your partner in navigating the complex cybersecurity landscape.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}